import * as styledComponents from "styled-components";
const { default: styled, css, keyframes, ThemeProvider, withTheme, } = styledComponents;
export { styled, css, keyframes, ThemeProvider, withTheme };
export default styled;
//# sourceMappingURL=index.js.map